module.exports = __webpack_public_path__ + "img/bx.cba26b6b.png";